import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Button, Form, Input, Typography } from 'antd';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import { isLoggedIn, saveToken } from '../auth';
import { API_BASE } from '../App';

const { Title, Text, Link } = Typography;

export default function LoginPage() {
  const navigate              = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);
  const [form]                = Form.useForm();

 useEffect(() => {
  if (isLoggedIn()) {
    sessionStorage.clear();   // wipes token + user
  }
}, []);

  async function handleSubmit(values) {
    setError(null);
    setLoading(true);

    const hashedPassword = CryptoJS.MD5(values.password).toString();

    try {
      const res = await axios.post(`${API_BASE}/login`, {
        email:    values.email.trim(),
        password: hashedPassword,
        userType: '2',
      });

      const { success, token, message, user } = res.data;

      if (success && token) {
        saveToken(token, user);
        navigate('/coc_ui', { replace: true });
      } else {
        setError(message || 'Login failed. Please check your credentials.');
      }
    } catch {
      setError('Invalid email or password. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex',
      alignItems: 'center', justifyContent: 'center',
      background: '#fff', padding: '24px 16px',
    }}>
      <div style={{ width: '100%', maxWidth: 420 }}>

        <div style={{
          fontSize: 22, fontWeight: 800, letterSpacing: '.18em',
          color: '#141414', marginBottom: 28,
        }}>
          DURACAN
        </div>

        <Title level={3} style={{ margin: '0 0 4px', fontWeight: 700, color: '#141414' }}>
          Sign in to your account
        </Title>
        <Text type="secondary" style={{ display: 'block', marginBottom: 28, fontSize: 14 }}>
          Use your registered email to sign in
        </Text>

        {error && (
          <Alert type="error" message={error} showIcon closable
            onClose={() => setError(null)} style={{ marginBottom: 20 }} />
        )}

        <Form form={form} layout="vertical" onFinish={handleSubmit}
          requiredMark={false} initialValues={{ userType: '2' }}>

          <Form.Item
            label={<Text strong style={{ fontSize: 13 }}>Email</Text>}
            name="email"
            rules={[
              { required: true, message: 'Please enter your email.' },
              { type: 'email', message: 'Please enter a valid email address.' },
            ]}
          >
            <Input size="large" placeholder="Enter your email"
              autoComplete="email" inputMode="email" style={{ borderRadius: 6 }} />
          </Form.Item>

          <Form.Item
            label={<Text strong style={{ fontSize: 13 }}>Password</Text>}
            name="password"
            rules={[{ required: true, message: 'Please enter your password.' }]}
          >
            <Input.Password size="large" placeholder="Enter your password"
              autoComplete="current-password" style={{ borderRadius: 6 }}
              iconRender={v => v ? <EyeOutlined /> : <EyeInvisibleOutlined />} />
          </Form.Item>

          <Form.Item style={{ marginTop: 8 }}>
            <Button htmlType="submit" loading={loading} size="large" style={{
              width: '100%', background: '#d4b483', borderColor: '#d4b483',
              color: '#141414', fontWeight: 700, fontSize: 15,
              height: 50, borderRadius: 6, border: 'none',
            }}>
              {loading ? 'Signing in...' : 'Continue'}
            </Button>
          </Form.Item>
        </Form>

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 4, marginBottom: 24 }}>
          <Link href="#" style={{ fontSize: 13, color: '#595959' }}>Forgot Password</Link>
          <Link href="#" style={{ fontSize: 13, color: '#595959' }}>Sign up as a new user</Link>
        </div>

        <Text type="secondary" style={{ fontSize: 11, textAlign: 'center', display: 'block', lineHeight: 1.6 }}>
          By clicking "Continue with Email" you agree to the{' '}
          <Link href="#" style={{ fontSize: 11 }}>Terms and Service</Link>{' '}
          and acknowledge the{' '}
          <Link href="#" style={{ fontSize: 11 }}>Privacy Notice</Link>
        </Text>
      </div>
    </div>
  );
}